import { Log } from '@fanfanlo'
import { initTriggers } from './initTriggers'
import { initActions } from './initActions'

const fileLog = new Log(false, 'initProjectSystem_f')
fileLog.pause = true
fileLog.childrenPaused = true

/**
 * 初始化项目系统
 * 在应用启动时调用，初始化所有 triggers 和 actions
 */
export function initProjectSystem() {
    fileLog.log('[initProjectSystem] 开始初始化项目系统')

    fileLog.log('[initProjectSystem] 初始化 triggers...')
    initTriggers()
    fileLog.log('[initProjectSystem] triggers 初始化完成')

    fileLog.log('[initProjectSystem] 初始化 actions...')
    initActions()
    fileLog.log('[initProjectSystem] actions 初始化完成')

    fileLog.log('[initProjectSystem] 项目系统初始化完成')
}
